export default function ProductCard({ product, onAddToCart, compact = false }) {
  return (
    <div className="product-card">
      <div className="product-image">
        <img
          src={product.image || "/placeholder.svg"}
          alt={product.name}
        />
      </div>
      <div className="product-info">
        <h3>{product.name}</h3>
        {product.type ? <div className="product-meta">{product.type}</div> : null}
        <p className="description">
          {compact && product.description?.length > 50
            ? `${product.description.slice(0, 50)}...`
            : product.description}
        </p>
        {"stock" in product && (
          <div className="product-meta">
            <span className={`stock ${product.stock > 0 ? "in-stock" : "out-of-stock"}`}>
              {product.stock > 0 ? `In Stock (${product.stock})` : "Out of Stock"}
            </span>
          </div>
        )}
        <div className="product-footer">
          <span className="price">${Number(product.price).toFixed(2)}</span>
          {typeof onAddToCart === "function" && (
            product.stock > 0 || !("stock" in product) ? (
              <button className="btn btn-sm btn-primary" onClick={() => onAddToCart(product.id)}>
                Add to Cart
              </button>
            ) : (
              <button className="btn btn-sm btn-secondary" disabled>
                Out of Stock
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
}
